import { z } from "zod";
import type { ResourceId} from "./resource-id";
import { resourceIdZodSchema } from "./resource-id";

type ResourceLink = {
    readonly _id: ResourceId;
};

const resourceLinkZodSchema: z.ZodSchema<ResourceLink> = z.object({
    _id: resourceIdZodSchema,
});

export type { ResourceLink };
export { resourceLinkZodSchema };
